export enum SelectionActions {
    complete = 'complete',
    skip = 'skip',
    noObjects = 'noObjects'
}